import { inject, injectable } from "inversify";
import { Field } from "sparkson";

@injectable()
export class Loop {
  constructor(
    @Field("s", true) public start: number = 0,
    @Field("d") public duration: number,
    @Field("jop", true) public jumpToOnPlay?: number,
  ) {}
}
